import {useContext, useMemo, useEffect, useState} from "react";
import {singletonHook} from 'react-singleton-hook';
import AppContext, {ISOLATED_PRODUCT} from "../store";
import {SYSTEM_ID_TOGGLE_DESK_CAMERA, SYSTEM_ID_TOGGLE_INSPECT} from "../contants/presets";

export const VIEW_MODE = 'view_mode';
export const VIEW_MODE_DEFAULT = 'view_mode_default';
export const VIEW_MODE_INSPECT = 'view_mode_inspect';
export const VIEW_MODE_ISOLATE = 'view_mode_isolate';
export const VIEW_MODE_DESK = 'view_mode_desk';

function useViewModeImpl() {
  const {
    streamStore,
  } = useContext(AppContext);
  const [mode, setMode] = useState(VIEW_MODE_DEFAULT);
  
  const isDefaultView = useMemo(() => mode === VIEW_MODE_DEFAULT, [mode]);
  const isInspectView = useMemo(() => mode === VIEW_MODE_INSPECT, [mode]);
  const isIsolateView = useMemo(() => mode === VIEW_MODE_ISOLATE, [mode]);
  const isDeskView = useMemo(() => mode === VIEW_MODE_DESK, [mode]);
  
  useEffect(() => {
    if (streamStore[ISOLATED_PRODUCT]) {
      setMode(VIEW_MODE_ISOLATE);
    } else if (streamStore[SYSTEM_ID_TOGGLE_INSPECT]) {
      setMode(VIEW_MODE_INSPECT);
    } else if (streamStore[SYSTEM_ID_TOGGLE_DESK_CAMERA]) {
      setMode(VIEW_MODE_DESK);
    } else {
      setMode(VIEW_MODE_DEFAULT);
    }

  }, [streamStore]);

  return {
    viewMode: mode,
    isDefaultView,
    isInspectView,
    isIsolateView,
    isDeskView,
  }
}

export default singletonHook({}, useViewModeImpl);
